queryHookDefaultOptions